/**
 * A `?next=` value that is safe to navigate to, or null.
 *
 * `next` comes straight from a URL anyone can craft, and it is used after a
 * sign-in or signup to send the person onward. Only a path on this site is
 * acceptable: "//evil.com" and "/\evil.com" are read by browsers as another
 * origin, and a full URL or "javascript:" is not a path at all. Control
 * characters are refused too, because browsers strip tabs and newlines from
 * URLs, which would turn "/\t/evil.com" into "//evil.com".
 */
export function safeNextPath(raw) {
  if (typeof raw !== 'string') return null;
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return null;
  // Control characters are the point: header injection and parser confusion.
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f\\]/.test(raw)) return null;
  return raw;
}
